import { IOption } from "@digital-services/ui";

import { OrganizationStatus } from "./OrganizationDetails";

export interface Organization {
  readonly id: string;
  readonly name: string;
  readonly countryName: string;
  readonly type: string;
  readonly status: OrganizationStatus;
  readonly createdOn: string;
  readonly externalId?: string;
}

export enum SearchOrganizationsByEnum {
  ByName = "byName",
  ByExternalId = "byExternalId"
}

export const firstSearchSelectOption: IOption = {
  value: SearchOrganizationsByEnum.ByName,
  label: "Name"
};
export const secondSearchSelectOption: IOption = {
  value: SearchOrganizationsByEnum.ByExternalId,
  label: "External ID"
};
export const searchOrganizationsBySelectOptions: IOption[] = [
  firstSearchSelectOption,
  secondSearchSelectOption
];

export const organizationsOptions = (
  organizations: Organization[]
): IOption[] => {
  return organizations?.map(element => {
    let label = element.name;

    if (element.status === OrganizationStatus.InActive) {
      label += " (deactivated)";
    }

    return {
      value: element.id,
      label
    };
  });
};
